import React, { useState } from 'react';
import { View } from 'react-native';
import { Box } from '@styleseat/ui';
import { HeaderText } from '../../../ui/HeaderText';

import { DeprecatedSearchTile } from '../SearchTile';
import './SearchTileGrid.module.scss';
import { useResponsiveEffect } from '../../../../hooks';

import { SearchPopoverModal } from '../../../consumer/search/SearchPopover';

import { ISearchTile } from '../SearchTile/SearchTile.types';

export type SearchTileGridProps = {
  onSelectTile?: (tile: ISearchTile) => void;
  showHeaderText?: boolean;
  tiles: ISearchTile[];
};

/**
 * Displays a grid of search tiles. The last search title is dropped on mobile.
 */
const DeprecatedSearchTileGrid = ({
  onSelectTile = () => { },
  showHeaderText = true,
  tiles,
}: SearchTileGridProps) => {
  const [shouldShowSearchModal, setShouldShowSearchModal] = useState(false);
  const is = useResponsiveEffect();

  return (
    <View styleName="container" testID="search-tile-grid">
      {shouldShowSearchModal && (
        <SearchPopoverModal onClose={() => setShouldShowSearchModal(false)} />
      )}
      {showHeaderText && (
        <Box paddingBottom={8}>
          <HeaderText
            level={2}
            fontSize={(is.mobile || is.tablet) ? 20 : 24}
          >
            Find top pros by service
          </HeaderText>
        </Box>
      )}
      <View
        nativeID="search-tile-grid"
        styleName="search-tile-grid"
      >
        {tiles.map(tile => (
          <View key={tile.text} styleName="search-tile">
            <DeprecatedSearchTile
              {...tile}
              onPress={() => onSelectTile(tile)}
            />
          </View>
        ))}
      </View>
    </View>
  );
};

export default DeprecatedSearchTileGrid;
